<template>
  <div class="pl-3 pr-3">
    <div>
      <priorities-list
        :priorities="active"
        editable
        deletable
        can-add
        @toggle="onToggle"
        @delete="onDelete"
      >
        <template #update="data">
          <slot name="update" v-bind="data" />
        </template>
        <template #add="data">
          <slot name="add" v-bind="data" />
        </template>
      </priorities-list>
    </div>
    <div v-if="!accomplishments" class="text-center">
      <b-button variant="link" @click.prevent="accomplishments=true">
        Show accomplishments
      </b-button>
    </div>
    <b-collapse v-model="accomplishments">
      <b-row class="align-items-center mt-5 mb-5">
        <b-col><div class="priorities-line" /></b-col>
        <b-col cols="auto"><h6>Accomplishments</h6></b-col>
        <b-col><div class="priorities-line" /></b-col>
      </b-row>
      <priorities-list
        :priorities="done"
        editable
        deletable
        @toggle="onToggle"
        @delete="onDelete"
      >
        <template #update="data">
          <slot name="update" v-bind="data" />
        </template>
        <template #add="data">
          <slot name="add" v-bind="data" />
        </template>
      </priorities-list>
      <div class="text-center mt-3">
        <b-button variant="link" @click.prevent="accomplishments=false">
          Show less
        </b-button>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { PrioritiesList } from '@/components/Priorities'

export default {
  name: 'EditPriorities',

  props: {
    priorities: {
      type: Array,
      default: () => ([])
    },

    toggleItem: {
      type: Function,
      required: true
    },

    deleteItem: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      accomplishments: true
    }
  },

  computed: {
    active() {
      return this.priorities.filter(p => !p.isDone)
    },

    done() {
      return this.priorities.filter(p => p.isDone)
    }
  },

  methods: {
    async onToggle({ id }) {
      await this.toggleItem(id)
    },

    async onDelete({ id }) {
      await this.deleteItem(id)
    }
  },

  components: {
    PrioritiesList
  }
}
</script>
